import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    dialog: false
  },

  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    }
  },

  actions: {
    read({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/youtube/assets/insert')
        .then(r => {
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  }
}
